import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Spinner } from "@krea/shared/design-system/Spinner";
import { useAuthStore } from "@krea/shared/features/auth/authStore";

import { useCurrentLenderCompanyStore } from "../lender-companies/current-lender-company-store";
import { useGetMyLenderCompaniesQuery } from "../lender-companies/hooks/use-get-my-lender-companies.query";
import { useGetMeQuery } from "../users/hooks/use-get-me.query";

export const RootPage = () => {
  const { data: me, isPending } = useGetMeQuery();
  const accessToken = useAuthStore((state) => state.accessToken);
  const companiesQuery = useGetMyLenderCompaniesQuery(
    {
      limit: 10,
      offset: 0,
    },
    {
      enabled: !!me,
    },
  );
  const currentLenderCompanyId = useCurrentLenderCompanyStore(
    (state) => state.lenderCompanyId,
  );
  const setCurrentLenderCompany = useCurrentLenderCompanyStore(
    (state) => state.setCurrentLenderCompany,
  );
  const clearCurrentLenderCompany = useCurrentLenderCompanyStore(
    (state) => state.clearCurrentLenderCompany,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if ((!me && !isPending) || !accessToken) {
      navigate("/login");

      return;
    }

    if (me?.isAdmin) {
      navigate("/select-lender-company");

      return;
    }

    if (!companiesQuery.data) {
      return;
    }

    const companies = companiesQuery.data.pages.flatMap((page) => page.items);

    if (currentLenderCompanyId) {
      const isValid = companies.some((c) => c.id === currentLenderCompanyId);

      if (isValid) {
        navigate(`/lender-company/${currentLenderCompanyId}`);

        return;
      }

      clearCurrentLenderCompany();
    }

    if (companies.length === 1) {
      const lenderCompanyId = companies[0]?.id;

      if (lenderCompanyId) {
        setCurrentLenderCompany(lenderCompanyId);
        navigate(`/lender-company/${lenderCompanyId}`);

        return;
      }
    }

    navigate("/select-lender-company");
  }, [
    companiesQuery.data,
    currentLenderCompanyId,
    navigate,
    setCurrentLenderCompany,
    clearCurrentLenderCompany,
    isPending,
    me,
    accessToken,
  ]);

  return (
    <div className="flex h-full items-center justify-center">
      <Spinner iconClassName="size-10" />
    </div>
  );
};
